<div class="container-center">
  <h3 class="main-title">
    RSM-ONLINE CLASSROOM
    <span class="title-accent">
      NOT FOUND
    </span>
  </h3>
  <div class="logo-center">
    <img src="assets/img/rsm_logo.svg" alt="rsm-logo" width="240px">
  </div>
  <h4 class="bottom-text">Classroom URL is not correct!</h4>
</div>
